import { Idv, Review } from './trip.type';
import { Trip, Unit, Reservation, Stay, RequiredActions, Access, Guests, HomeInfo, UnitAmenityCategory } from 'guest-data-types-ts-lib';
import { DetailedError } from './errors.type';

export interface TripState {
    isLoading: boolean;
    isCancelled: boolean;
    tripProtectionMessage?: string;
    shouldCleanCache: boolean;
    shouldShowEarlyCheckOut: boolean;
    error: DetailedError | null;
    id?: string;
    confirmation_code?: string;
    unit?: Unit;
    reservation?: Reservation;
    stay?: Stay;
    guests?: Guests;
    access?: Access;
    review?: Review;
    required_actions?: RequiredActions;
    unit_amenities?: UnitAmenityCategory[];
    home_info?: HomeInfo;
    departure?: string;
    idv?: Idv;
    isPoolHeatAvailable: boolean | null;
}

export enum TripActions {
    FETCH_BEGIN = 'FETCH_BEGIN',
    FETCH_SUCCESS = 'FETCH_SUCCESS',
    FETCH_ERROR = 'FETCH_ERROR',

    FETCH_FROM_ZERO = 'FETCH_FROM_ZERO',

    EDIT_GUESTS_SUCCESS = 'EDIT_GUESTS_SUCCESS',
    EDIT_GUESTS_ERROR = 'EDIT_GUESTS_ERROR',

    SET_CLEAN_CACHE_FLAG = 'SET_CLEAN_CACHE_FLAG',
    SET_EARLY_CHECKOUT_FLAG = 'SET_EARLY_CHECKOUT_FLAG',
    SET_IS_POOL_HEAT_AVAILABLE = 'SET_IS_POOL_HEAT_AVAILABLE',
    SET_RESERVATION_IS_CANCELLED = 'SET_RESERVATION_IS_CANCELLED',
    SET_RESERVATION_TRIP_PROTECTION_INFO = 'SET_RESERVATION_TRIP_PROTECTION_INFO',
}

interface FetchTripBegin {
    type: typeof TripActions.FETCH_BEGIN;
}

interface FetchTripFromZero {
    type: typeof TripActions.FETCH_FROM_ZERO;
}

interface FetchTripSuccess {
    type: typeof TripActions.FETCH_SUCCESS;
    payload: Trip;
}

interface FetchTripError {
    type: typeof TripActions.FETCH_ERROR;
    payload: DetailedError;
}

interface EditGuestsSuccess {
    type: typeof TripActions.EDIT_GUESTS_SUCCESS;
    payload: Guests;
}

interface EditGuestsError {
    type: typeof TripActions.EDIT_GUESTS_ERROR;
    payload: DetailedError;
}

interface SetCleanCacheFlag {
    type: typeof TripActions.SET_CLEAN_CACHE_FLAG;
    payload: boolean;
}

interface SetEarlyCheckoutFlag {
    type: typeof TripActions.SET_EARLY_CHECKOUT_FLAG;
    payload: boolean;
}

interface SetIsPoolHeatAvailable {
    type: typeof TripActions.SET_IS_POOL_HEAT_AVAILABLE;
    payload: boolean;
}

interface SetIsReservationCancelled {
    type: typeof TripActions.SET_RESERVATION_IS_CANCELLED;
    payload: boolean;
}

interface SetReservationTripProtectionInfo {
    type: typeof TripActions.SET_RESERVATION_TRIP_PROTECTION_INFO;
    payload: { trip_protection_message: string };
}

export type TripActionTypes =
    | FetchTripBegin
    | FetchTripFromZero
    | FetchTripSuccess
    | FetchTripError
    | EditGuestsSuccess
    | EditGuestsError
    | SetCleanCacheFlag
    | SetEarlyCheckoutFlag
    | SetIsPoolHeatAvailable
    | SetIsReservationCancelled
    | SetReservationTripProtectionInfo;
